import classNames from "classnames";
import { FC, useRef, useState } from "react";
import { BsShare } from "react-icons/bs";
import { MdVerified } from "react-icons/md";
import { API } from "../../services/api/types";
import IconWithTooltip from '../IconWithTooltip';
import { Media } from "../Media";
import Share from "../Share";
import styles from "./styles.module.css";
import FavoriteToggle from "../FavoriteToggle";

type ProfileImageProps = {
  person: API.Player | API.Manager | API.Agent;
  imgSrc: string;
  verified?: boolean;
  type?: "player" | "agent" | "manager";
};

const ProfileImageBig: FC<ProfileImageProps> = ({ person, imgSrc, verified, type }) => {
  const [showShareIcons, setShowShareIcons] = useState(false);
  const buttonRef = useRef(null);

  return (
    <div
      className={classNames({
        "md:mb-5": !person.imageSource,
        "md:mb-2.5": person.imageSource,
      })}
    >
      <div
        className={classNames([
          "relative",
          "bg-no-repeat",
          "aspect-w-16",
          "aspect-h-9",
          "bg-cover",
          styles["image"],
        ])}
        style={{
          backgroundImage: `url(${imgSrc})`,
        }}
      >
        <div className={classNames(["flex", "w-full"])}>
          <div
            className={classNames(
              "bg-gradient-to-t",
              "from-[#222323]",
              "bg-size-full",
              "bg-no-repeat",
              "bg-bottom",
              "mt-auto",
              "pt-16",
              "w-full"
            )}
          >
            <h1
              className={classNames(
                "bottom-5",
                "text-white",
                "text-semibold",
                "text-xl",
                "sm:text-4xl",
                "mx-6",
                "mb-6",
                "flex"
              )}
            >
              {person.name}
              {verified ? <div className={classNames(
                  "flex",
                  "items-center",
                  "text-sm",
                  "ml-1",
                  "mt-1",
                  "whitespace-nowrap"
                )}>
                  <IconWithTooltip
                  
                                    text={'Licensierad agent'}
                                    icon={
                                      <MdVerified
                    style={{
                      width: "1.5rem",
                      height: "1.5rem",
                      color: "#75A82D",
                      overflow: 'hidden'
                    }}
                  />
                                    }
                                  />
              </div> : null}
              <div
                className={classNames(
                  "flex",
                  "items-center",
                  "hover:cursor-pointer",
                  "ml-4",
                  "mt-1"
                )}
              >
                <div ref={buttonRef}>
                  <BsShare
                    onClick={() => setShowShareIcons(!showShareIcons)}
                    style={{
                      width: "1.5rem",
                      height: "1.5rem",
                      color: "white",
                    }}
                  />
                </div>
                <Share buttonRef={buttonRef} isOpen={showShareIcons} />
              </div>

              <div
                className={classNames(
                  "flex",
                  "items-center",
                  "hover:cursor-pointer",
                  "ml-4",
                  "mt-1"
                )}
              >
                {type && (
                  <FavoriteToggle
                    type={type}
                    favorite={{
                      id: person.id,
                      image: person.imageSmall,
                      name: person.name,
                    }}
                    style={{
                      width: "1.5rem",
                      height: "1.5rem",
                      color: "white",
                    }}
                  />
                )}
              </div>
            </h1>
          </div>
        </div>
      </div>
      <Media greaterThanOrEqual="sm">
        {person.imageSource && (
          <p
            className={classNames([
              "block",
              "text-right",
              "text-custom-gray",
              "text-sm",
            ])}
          >
            Foto: {person.imageSource}
          </p>
        )}
      </Media>
    </div>
  );
};

export default ProfileImageBig;
